import { MutableRefObject, RefCallback } from 'react'

type Ref<T> = MutableRefObject<T> | RefCallback<T> | null | undefined

export const mergeRefs = <T>(...refs: Ref<T>[]): RefCallback<T> | null => {
  const filteredRefs = refs.filter(Boolean) as (MutableRefObject<T> | RefCallback<T>)[]
  if (!filteredRefs.length) return null
  if (filteredRefs.length === 1) {
    const ref = filteredRefs[0]
    if (typeof ref === 'function') return ref
    return (e: T) => {
      ref.current = e
    }
  }
  return (e: T) => {
    filteredRefs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(e)
      } else {
        ref.current = e
      }
    })
  }
}
